import { IProductCategory } from 'models/StockManage/CateProductManage';
import React from 'react';
import create from 'zustand';
import UtilOrder from './utilOrder';
import { IDetailsItem } from 'models/CreateOrder';
import { addNewLines, addOrderLines, isSameLine } from './hook/deviceLines';
import AdminLogApi from 'apis/api/AdminLog';
import { TACH_DONG_SP } from '@lib/featureFlags';
// lõi xử lý các sự kiện liên quan đến tao tác các sản phẩm thiết bị của đơn hàng
// cần theo dõi xem dữ liệu bên ô tìm kiếm có ảnh hưởng đến dữ liệu device bên này hay k

let productCateList: any[] = [];

// Cờ OMConfig TachDongSanPham: data = 1 -> mỗi lần chọn SP là 1 dòng riêng (bản mới, cần server hỗ trợ).
// Chưa tạo key / khác 1 / lỗi -> gộp theo mã như cũ. Đọc 1 lần mỗi lần tải trang (lúc nạp danh mục SP).
// Bật/tắt ở src/lib/featureFlags.ts (TACH_DONG_SP)
const tachDongSP = TACH_DONG_SP;
const daDocCoTachDong = true;
const docCoTachDong = () => {
  if (daDocCoTachDong) return;
  // daDocCoTachDong = true;
  // AdminLogApi.GetConfigWithKey('TachDongSanPham').then((res: any) => {
  //   tachDongSP = !res?.data?.error && Number(res?.data?.data?.data || 0) === 1;
  // });
};

// Phần xử lý cập nhật thiết bị, chỉ dành riêng cho lúc mới cập nhật, đổ data từ đơn hàng vô
const processAddOrderUpdate = (
  devices: IProductCategory[],
  deviceNames: any[],
  quantity: any[],
  arrGiaBanSi: any[],
  detail?: any[],
  idS?: any[]
) => addOrderLines(devices, productCateList, deviceNames, quantity, arrGiaBanSi, detail, idS, tachDongSP);

const deleteDetailItem = (devices: IProductCategory[], item: IDetailsItem, data: IProductCategory) => {
  const listTemp = UtilOrder.deleteDetailItem(item, data, devices);
  return [listTemp];
};

const addAddDetailToItem = (
  devices: IProductCategory[],
  serial: string,
  Bs: string,
  vehicleType: string,
  data: IProductCategory,
  isUpdate?: boolean
) => {
  const listTemp = UtilOrder.addDetailToItem(serial, Bs, vehicleType, data, devices, isUpdate);
  if (listTemp.length !== 0) {
    // ok
    return [listTemp];
  }
  if (listTemp.length === 0) {
    return -1;
  }
};

const addQuickSerialToItem = (
  devices: IProductCategory[],
  startSerial: string,
  data: IProductCategory,
  amount: number
) => {
  const listTemp = UtilOrder.addQuickDetailToItem(startSerial, data, devices, amount);
  if (listTemp.length !== 0) {
    // ok
    return [listTemp];
  }
  if (listTemp.length === 0) {
    return -1;
  }
};

// Hàm xử lý đưa các thiết bị bao gồm cả chi  tiết của tb trong đơn hàng để cập nhật..
const addUpdateDevice = async (
  devices: IProductCategory[],
  deviceNames: any,
  quantity: any,
  arrGiaBanSi: any,
  detail?: any,
  idS?: any
) => {
  const arrayListResult = await processAddOrderUpdate(devices, deviceNames, quantity, arrGiaBanSi, detail, idS);
  // console.log('addUpdateDevice', arrayListResult);
  return [arrayListResult];
};

// Phần xử lý tạo thiết bị từ đây

// Thêm nhanh / thêm 1 sản phẩm: mỗi lần chọn là 1 dòng mới (không cộng dồn theo mã), KD tự tăng SL/sửa giá
const proccessAddQuick = (devices: IProductCategory[], deviceNames: string[], quantity?: number) =>
  addNewLines(devices, productCateList, deviceNames, quantity, tachDongSP);

const proccessAddDevice = (devices: IProductCategory[], deviceName: string, quantity?: number) =>
  addNewLines(devices, productCateList, [deviceName], quantity, tachDongSP);

const onChangePrice = (
  value: React.ChangeEvent<HTMLInputElement>,
  itemP: IProductCategory,
  devices: IProductCategory[]
) => {
  const listTemp = UtilOrder.changePrice(value, itemP, devices);
  return [listTemp];
};

const onChangeQuantity = (
  value: React.ChangeEvent<HTMLInputElement>,
  itemQ: IProductCategory,
  devices: IProductCategory[]
) => {
  const listTemp = UtilOrder.changeQuantity(value, itemQ, devices);
  return [listTemp];
};

const goUpQuantity = (itemU: IProductCategory, devices: IProductCategory[]) => {
  console.log(itemU, devices);
  const listTemp = UtilOrder.upQuantity(itemU, devices);
  return [listTemp];
};

const goDownQuantity = (itemD: IProductCategory, devices: IProductCategory[]) => {
  console.log(itemD, devices);
  const listTemp = UtilOrder.downQuantity(itemD, devices);
  return [listTemp];
};

const removeProductCategory = (devices: IProductCategory[], device: IProductCategory) => {
  const listTemp = devices.filter((item: IProductCategory) => !isSameLine(item, device));
  return [listTemp];
};

// thêm nhanh list device category vào list
const addProductCategoryQuick = (devices: IProductCategory[], deviceNames: string[], quantity?: number) => {
  const arrayListResult = proccessAddQuick(devices, deviceNames, quantity);
  // if (arrayListResult) console.log(arrayListResult);
  return [arrayListResult];
};

// thêm 1 device category vào list
const addProductCategory = (devices: IProductCategory[], deviceName: string, quantity?: number) => {
  const arrayListResult = proccessAddDevice(devices, deviceName, quantity);
  return [arrayListResult];
};

// đẩy vào 1 list mới
// const setProductCategory = (
//   devices: IProductCategory[],
//   device: IProductCategory,
//   quantity?: number
// ): IProductCategory[] => [
//   ...devices,
//   device,
// ];

type StoreProductCate = {
  devices: any[];
  newTodo?: string;
  addDeviceCreate?: (deviceNames: string[], quantity: any, arrGiaBanSi: any, details: any) => void;
  addDeviceUpdate?: (deviceNames: string[], quantity: any, arrGiaBanSi: any, details: any, idS: any) => void;
  onDeleteDetailItem?: (item: IDetailsItem, data: IProductCategory) => void;
  onAddDetailToItem?: (
    serial: string,
    Bs: string,
    vehicleType: string,
    data: IProductCategory,
    isUpdate?: boolean
  ) => void;
  onAddQuickSerialToItem?: (startSerial: string, data: IProductCategory, amount: number) => void;
  // phần thêm mới có thể kết hợp
  setDevice: (devices: IProductCategory[]) => void;
  updatePrice: (value: React.ChangeEvent<HTMLInputElement>, itemP: IProductCategory) => void;
  updateQuantity: (value: React.ChangeEvent<HTMLInputElement>, itemQ: IProductCategory) => void;
  goUpQuantity: (device: IProductCategory) => void;
  goDownQuantity: (device: IProductCategory) => void;
  removeDevice: (device: IProductCategory) => void;
  addDevice: (deviceName: string, quantity?: number) => void;
  addDeviceQuick: (deviceName: string[], quantity?: number) => void;
  resetListDevice: () => void;
};

const SetProductMixData = (data: any[]) => {
  docCoTachDong();
  // console.log('SetProductMixData', productCateList, data);
  productCateList = [...new Map([...productCateList.concat(data)].map(prod => [prod.name, prod])).values()].map(
    item => ({ ...item, Quantity: 0 })
  );
};

const useStoreCreateOrder = create<StoreProductCate>(
  (set, get): StoreProductCate => ({
    devices: [],
    newTodo: '',
    setDevice: (devices: IProductCategory[]) =>
      set(state => ({
        ...state,
        devices
      })),
    updatePrice: (value: React.ChangeEvent<HTMLInputElement>, itemP: IProductCategory) =>
      set(state => ({
        ...state,
        devices: onChangePrice(value, itemP, state.devices[0])
      })),
    updateQuantity: (value: React.ChangeEvent<HTMLInputElement>, itemQ: IProductCategory) =>
      set(state => ({
        ...state,
        devices: onChangeQuantity(value, itemQ, state.devices[0])
      })),
    goUpQuantity: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: goUpQuantity(device, state.devices[0])
      })),
    goDownQuantity: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: goDownQuantity(device, state.devices[0])
      })),
    removeDevice: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: removeProductCategory(state.devices[0], device)
      })),
    addDevice: (deviceName: string, quantity?: number) =>
      set(state => ({
        ...state,
        devices: addProductCategory(state.devices[0], deviceName, quantity)
      })),
    addDeviceCreate: async (deviceNames: string[], quantity: any, arrGiaBanSi: any, details: any) => {
      const rlt = await addUpdateDevice(get().devices[0], deviceNames, quantity, arrGiaBanSi, details);

      if (rlt) {
        set(state => ({
          ...state,
          devices: rlt
        }));
      }
    },
    addDeviceQuick: (deviceNames: string[], quantity?: number) =>
      set(state => ({
        ...state,
        devices: addProductCategoryQuick(state.devices[0], deviceNames, quantity)
      })),
    resetListDevice: () => {
      set(state => ({
        ...state,
        devices: []
      }));
    }
  })
);

const useStoreUpdateOrder = create<StoreProductCate>(
  (set, get): StoreProductCate => ({
    devices: [],
    newTodo: '',
    setDevice: (devices: IProductCategory[]) =>
      set(state => ({
        ...state,
        devices
      })),
    onDeleteDetailItem: (item: IDetailsItem, data: IProductCategory) =>
      set(state => ({
        ...state,
        devices: deleteDetailItem(state.devices[0], item, data)
      })),
    onAddDetailToItem: (
      serial: string,
      Bs: string,
      vehicleType: string,
      data: IProductCategory,
      isUpdate?: boolean
    ) => {
      const rlt = addAddDetailToItem(get().devices[0], serial, Bs, vehicleType, data, isUpdate);
      if (rlt != -1) {
        set(state => ({
          ...state,
          devices: rlt
        }));
        return 1;
      } else return rlt;
    },
    onAddQuickSerialToItem: (startSerial: string, data: IProductCategory, amount: number) => {
      const rlt = addQuickSerialToItem(get().devices[0], startSerial, data, amount);
      if (rlt != -1) {
        set(state => ({
          ...state,
          devices: rlt
        }));
        return 1;
      } else return rlt;
    },

    addDeviceUpdate: async (deviceNames: string[], quantity: any, arrGiaBanSi: any, details: any, idS: any) => {
      const rlt = await addUpdateDevice(get().devices[0], deviceNames, quantity, arrGiaBanSi, details, idS);

      if (rlt) {
        set(state => ({
          ...state,
          devices: rlt
        }));
      }
    },

    updatePrice: (value: React.ChangeEvent<HTMLInputElement>, itemP: IProductCategory) =>
      set(state => ({
        ...state,
        devices: onChangePrice(value, itemP, state.devices[0])
      })),
    updateQuantity: (value: React.ChangeEvent<HTMLInputElement>, itemQ: IProductCategory) =>
      set(state => ({
        ...state,
        devices: onChangeQuantity(value, itemQ, state.devices[0])
      })),
    goUpQuantity: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: goUpQuantity(device, state.devices[0])
      })),
    goDownQuantity: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: goDownQuantity(device, state.devices[0])
      })),
    removeDevice: (device: IProductCategory) =>
      set(state => ({
        ...state,
        devices: removeProductCategory(state.devices[0], device)
      })),
    addDevice: (deviceName: string, quantity?: number) =>
      set(state => ({
        ...state,
        devices: addProductCategory(state.devices[0], deviceName, quantity)
      })),

    addDeviceQuick: (deviceNames: string[], quantity?: number) =>
      set(state => ({
        ...state,
        devices: addProductCategoryQuick(state.devices[0], deviceNames, quantity)
      })),
    resetListDevice: () => {
      set(state => ({
        ...state,
        devices: []
      }));
    }
  })
);

export { useStoreCreateOrder, useStoreUpdateOrder, SetProductMixData };
